import { type QueryFunctionContext } from '@tanstack/react-query'
import { type CreditDetailsResponse } from '@/features/purchase/services/Wallet/types'
import { apiGet } from '@/features/shared/utils/dataFetching'

export const fetchCreditDetails = (context: QueryFunctionContext) => {
  return apiGet<CreditDetailsResponse>({
    config: {
      url: '/marketplace-broker/v1/credits/details',
    },
    context,
    fetcherName: 'fetchCreditDetails',
  })
}
